import { getImageCloudUrlWithTransformations } from '@nw/shared/utils';

export const paymentModeFieldConstants = {
  razorPayPaymentMode: 'razorPayPaymentMode',
  jusPayPaymentMode: 'jusPayPaymentMode'
};

export const paymentModesConstants = {
  bankTransfer: 'BANK_TRANSFER',
  digitalPayment: 'DIGITAL_PAYMENT'
};

export const paymentGatewayImageConstants = {
  razorPay: getImageCloudUrlWithTransformations('sso/common/razorpay.png', {}),
  shopse: getImageCloudUrlWithTransformations(
    'sso/common/shopse-no-cost-emi-image.png',
    {}
  ),
  jusPay: getImageCloudUrlWithTransformations('sso/common/juspay.png', {})
};

export const digitalPaymentModesImageConstant = {
  upi: getImageCloudUrlWithTransformations(
    'sso/payment-modes/upi-logo.png',
    {}
  ),
  googlePay: getImageCloudUrlWithTransformations(
    'sso/payment-modes/googlepay-logo.png',
    {}
  ),
  phonePe: getImageCloudUrlWithTransformations(
    'sso/payment-modes/phonepay-logo.png',
    {}
  ),
  paytm: getImageCloudUrlWithTransformations(
    'sso/payment-modes/paytm-logo.png',
    {}
  ),
  masterCard: getImageCloudUrlWithTransformations(
    'sso/payment-modes/mastercard-logo.png',
    {}
  ),
  visa: getImageCloudUrlWithTransformations(
    'sso/payment-modes/visa-logo.png',
    {}
  )
};

export const bankTransferPaymentModeImage = getImageCloudUrlWithTransformations(
  'sso/payment-modes/bank-transfer.png',
  {}
);

export const INSTALLMENT_ORDER_STATUS_CHECK_ROUTE_PATH =
  '/installment/order/status/check';

export const ORDER_STATUS_CHECK_ROUTE_PATH = '/order/status/check';
